import type { SVGProps } from "react";
export interface BreadSliceIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BreadSliceIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BreadSliceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6.75c0-.676-.198-1.18-.532-1.589-.35-.427-.9-.81-1.69-1.128-1.605-.643-3.928-.908-6.652-.908s-5.05.265-6.654.908c-.79.317-1.34.701-1.69 1.128-.334.408-.532.913-.532 1.59 0 .521.098.896.246 1.177.146.277.374.526.731.752.326.206.523.565.523.95V19c0 1.035.84 1.875 1.875 1.875h11c1.035 0 1.875-.84 1.875-1.875V9.63c0-.385.198-.744.524-.95.357-.226.585-.475.73-.752.149-.281.245-.656.245-1.178Zm2.25 0c0 .807-.152 1.557-.504 2.226a4.1 4.1 0 0 1-.996 1.223v8.8a4.125 4.125 0 0 1-4.125 4.126h-11A4.125 4.125 0 0 1 2.375 19v-8.803a4.1 4.1 0 0 1-.995-1.221C1.028 8.306.875 7.557.875 6.75c0-1.17.362-2.184 1.04-3.013.663-.81 1.577-1.383 2.596-1.791C6.526 1.138 9.203.875 12 .875s5.474.263 7.49 1.07c1.018.41 1.931.983 2.593 1.792.679.83 1.04 1.843 1.04 3.013Z"
      />
      <path
        fill={color}
        d="M11.5 17.627a.62.62 0 0 0-.126.373l.014.125a.6.6 0 0 0 .113.247zm1 .745a.6.6 0 0 0 .112-.247l.014-.125-.014-.127a.6.6 0 0 0-.113-.246zm3-6.743a.62.62 0 0 0-.125.37l.013.127a.6.6 0 0 0 .111.244zm1 .741a.6.6 0 0 0 .113-.244l.012-.127-.012-.126a.6.6 0 0 0-.113-.244zm-7.888-.496a.6.6 0 0 0-.112-.245v.741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126ZM7.5 11.629a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm4-6.002a.62.62 0 0 0-.126.373l.014.125a.6.6 0 0 0 .113.247zm1 .745a.6.6 0 0 0 .112-.247L12.626 6l-.014-.126a.6.6 0 0 0-.113-.247zM13.623 18a1.625 1.625 0 0 1-3.241.166L10.376 18l.007-.166a1.626 1.626 0 0 1 3.242.166Zm-3.999-6a1.625 1.625 0 0 1-3.242.167l-.008-.168.009-.165A1.625 1.625 0 0 1 8 10.375l.166.009c.82.083 1.46.774 1.46 1.615Zm8 0a1.626 1.626 0 0 1-3.242.166L14.375 12l.008-.165A1.626 1.626 0 0 1 16 10.375l.166.009c.82.083 1.459.774 1.459 1.615Zm-4-6a1.625 1.625 0 0 1-3.242.167L10.376 6l.007-.166A1.626 1.626 0 0 1 13.625 6Z"
      />
    </svg>
  );
}
